<template>
	<div class="order-detail-body">
		<!-- 订单概要 -->
		<div class="order-summary">
			<div class="summary-item">
				<span class="summary-label">订单编号：</span>
				<span class="summary-value">{{ orderInfo.orderCode }}</span>
			</div>
			<div class="summary-item">
				<span class="summary-label">商品信息：</span>
				<span class="summary-value">{{ orderInfo.eventName || '' }}</span>
			</div>
			<div class="summary-item">
				<span class="summary-label">付款时间：</span>
				<span class="summary-value">{{ orderInfo.payTime || '' }}</span>
			</div>
		</div>

		<!-- 待发布详情 -->
		<div class="order-detail-main">
			<div class="detail-panel">
				<div class="panel-title">
					<span>待发布详情</span>
				</div>

				<!-- 基础信息网格 -->
				<div class="detail-grid">
					<div class="detail-item">
						<span class="detail-label">申请企业：</span>
						<span class="detail-value">{{ displayInfo.companyName || '' }}</span>
					</div>
					<div class="detail-item">
						<span class="detail-label">联系电话：</span>
						<span class="detail-value">{{ displayInfo.telephone || '' }}</span>
					</div>
					<div class="detail-item">
						<span class="detail-label">所属板块：</span>
						<span class="detail-value">{{ displaySectorName }}</span>
					</div>
					<div class="detail-item">
						<span class="detail-label">售价：</span>
						<span class="detail-price">
							¥
							<strong>{{ displayInfo.sellingPrice || '' }}</strong>
							<em>{{ formatDuration(displayInfo.purchaseTime || '') }}</em>
						</span>
					</div>
				</div>

				<!-- 独占一行字段 -->
				<div class="detail-block">
					<div class="block-label">展示图：</div>
					<div class="block-content">
						<div class="image-list">
							<el-image
								v-for="item in displayImages"
								:key="item.fileId"
								class="thumb preview-image"
								:src="item.url"
								fit="cover"
								:preview-src-list="[item.url]"
							></el-image>
						</div>
					</div>
				</div>

				<div class="detail-block">
					<div class="block-label">宣传标题：</div>
					<div class="block-content">
						<div class="text-content">{{ displayInfo.title || '' }}</div>
					</div>
				</div>

				<div class="detail-block">
					<div class="block-label">宣传简介：</div>
					<div class="block-content">
						<div class="text-content">{{ displayInfo.displayDetails || '' }}</div>
					</div>
				</div>

				<div class="detail-block">
					<div class="block-label">附件资料：</div>
					<div class="block-content">
						<div v-if="displayAttachments.length" class="attachment-list">
							<div v-for="file in displayAttachments" :key="file.fileId || file.id" class="attachment-item">
								<i class="el-icon-document" />
								<span class="file-name" :title="file.name || file.fileName">{{ file.name || file.fileName }}</span>
								<el-button type="text" size="mini" icon="el-icon-view" @click="handlePreviewPublishFile(file)">预览</el-button>
							</div>
						</div>
						<div v-else class="text-content text-empty">暂无附件</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { previewMerchantFile, queryMerchantFileList, queryMerchantOrderDetail } from '@/api/mall'
	import { ENUM_DISPLAY_SECTOR, FILE_BUSINESS_TYPE } from '@/enum'

	/**
	 * @description 订单详情组件
	 */
	export default {
		name: 'OrderDetail',
		props: {
			id: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				orderInfo: {
					orderCode: '',
					payTime: '',
					paymentType: '',
					price: '',
					orderType: ''
				},
				displayInfo: {},
				displayImages: [],
				displayAttachments: []
			}
		},
		computed: {
			displaySectorName() {
				return ENUM_DISPLAY_SECTOR[this.displayInfo.displaySector] || ''
			}
		},
		mounted() {
			this.handleQueryOrderDetail()
			this.handleQueryDisplayImageFile()
			this.handleQueryDisplayAttachmentFile()
		},
		methods: {
			// 查询订单详情
			handleQueryOrderDetail() {
				const params = { id: this.id }
				queryMerchantOrderDetail(params).then(response => {
					const { data } = response
					this.orderInfo.orderCode = data.orderCode || ''
					this.orderInfo.payTime = data.payTime || ''
					this.orderInfo.paymentType = data.paymentType || ''
					this.orderInfo.price = data.price || ''
					this.orderInfo.orderType = data.orderType || ''
					this.orderInfo.eventName = data.eventName || ''
					this.displayInfo = data.merchantDisplayInfo || {}
				})
			},

			// 格式化时长显示
			formatDuration(days) {
				if (!days) return ''
				const daysNum = parseInt(days)
				if (daysNum >= 365) {
					const years = Math.floor(daysNum / 365)
					return `${years}年`
				} else {
					const months = Math.ceil(daysNum / 30)
					return `${months}个月`
				}
			},

			// 查询展示图文件
			handleQueryDisplayImageFile() {
				const params = {
					businessId: this.id,
					fileBusinessType: FILE_BUSINESS_TYPE.DISPLAY_IMAGE
				}
				queryMerchantFileList(params).then(response => {
					const { data } = response
					this.displayImages = data.map(item => ({
						fileId: item.id,
						url: previewMerchantFile() + item.id
					}))
				})
			},

			// 查询展示附件文件
			handleQueryDisplayAttachmentFile() {
				const params = {
					businessId: this.id,
					fileBusinessType: FILE_BUSINESS_TYPE.ATTACHMENT
				}
				queryMerchantFileList(params).then(response => {
					this.displayAttachments = response.data || []
				})
			},

			// 预览发布信息附件
			handlePreviewPublishFile(file) {
				const fileId = file.fileId || file.id
				if (!fileId) {
					this.$message.warning('文件信息缺失')
					return
				}
				window.open(previewMerchantFile() + fileId)
			}
		}
	}
</script>

<style lang="scss" scoped>
	// ==================== 变量定义 ====================
	$label-color: #333;
	$value-color: #6e6e6e;
	$primary-color: #ff6d00;
	$bg-gradient-start: #edf4ff;
	$bg-gradient-end: #f7fbff;

	// ==================== 根容器 ====================
	.order-detail-body {
		min-height: 477px;
		box-sizing: border-box;
		font-size: 14px;
		color: $label-color;
		line-height: 1.5;
	}

	// ==================== 订单概要 ====================
	.order-summary {
		display: grid;
		grid-template-columns: 350px 1fr 308px;
		row-gap: 18px;
		padding: 0 24px 18px;
		line-height: 18px;

		.summary-item {
			display: flex;
			align-items: center;
			min-width: 0;

			.summary-label {
				flex-shrink: 0;
				white-space: nowrap;
			}
		}
	}

	// ==================== 详情主体 ====================
	.order-detail-main {
		padding: 0;
		background: url('~@/assets/member/bgPic.png') no-repeat;
		background-size: 100%;
	}

	// ==================== 详情面板 ====================
	.detail-panel {
		position: relative;
		min-height: 386px;
		padding: 29px 23px 24px;
		overflow: hidden;
		background: linear-gradient(180deg, $bg-gradient-start 0%, $bg-gradient-end 100%);
		border-radius: 15px 15px 0 0;
		box-sizing: border-box;

		// 右下角装饰图
		&::after {
			content: '';
			position: absolute;
			right: 0;
			bottom: 0;
			width: 281px;
			height: 215px;
			background: url('~@/assets/member/right-bottom.png') right bottom / contain no-repeat;
			pointer-events: none;
		}
	}

	// ==================== 面板标题 ====================
	.panel-title {
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
		margin: 0 auto 32px;
		width: 520px;
		font-size: 15px;
		font-weight: 700;
		line-height: 18px;

		span {
			position: relative;
			margin: 0 24px;

			&::before,
			&::after {
				content: '';
				position: absolute;
				top: 50%;
				width: 225px;
				height: 21px;
				background-repeat: no-repeat;
				background-size: 100% 100%;
				transform: translateY(-50%);
			}

			&::before {
				right: 100%;
				margin-right: 18px;
				background-image: url('~@/assets/member/left.jpg');
			}

			&::after {
				left: 100%;
				margin-left: 18px;
				background-image: url('~@/assets/member/right.jpg');
			}
		}
	}

	// ==================== 基础信息网格 ====================
	.detail-grid {
		display: grid;
		grid-template-columns: 350px 1fr 330px;
		row-gap: 28px;
		position: relative;
		z-index: 1;
	}

	.detail-item {
		display: flex;
		align-items: baseline;
		min-width: 0;
		line-height: 18px;

		&.detail-item-wide {
			grid-column: 1 / -1;
		}
	}

	.detail-label {
		flex-shrink: 0;
		white-space: nowrap;
	}

	.detail-value {
		min-width: 0;
		color: $value-color;
		word-break: break-all;
	}

	.detail-price {
		color: $primary-color;
		font-size: 16px;
		line-height: 20px;

		strong {
			font-size: 24px;
			font-weight: 500;
		}

		em {
			margin-left: 6px;
			color: $label-color;
			font-size: 14px;
			font-style: normal;
		}
	}

	// ==================== 独占一行字段 ====================
	.detail-block {
		position: relative;
		z-index: 1;
		display: flex;
		align-items: flex-start;
		margin-top: 24px;
		line-height: 18px;

		.block-label {
			width: 84px;
			flex-shrink: 0;
			white-space: nowrap;
		}

		.block-content {
			flex: 1;
			min-width: 0;
		}
	}

	// ==================== 图片列表 ====================
	.image-list {
		display: flex;
		flex-wrap: wrap;
		gap: 10px;
	}

	.thumb {
		position: relative;
		width: 70px;
		height: 70px;
		overflow: hidden;
		background: #fff;
		border-radius: 4px;
		box-sizing: border-box;

		&.preview-image {
			cursor: pointer;

			::v-deep .el-image__inner {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}

			&:hover {
				opacity: 0.9;
			}
		}
	}

	// ==================== 文本内容 ====================
	.text-content {
		color: $value-color;
		word-break: break-all;
		line-height: 1.6;

		&.text-empty {
			color: #999;
			font-style: italic;
		}
	}

	// ==================== 附件列表 ====================
	.attachment-list {
		background: #fff;
		padding: 10px 16px;
		border-radius: 4px;
	}

	.attachment-item {
		display: flex;
		align-items: center;
		padding: 8px 0;
		border-bottom: 1px dashed #ebeef5;

		&:last-child {
			border-bottom: none;
		}

		.el-icon-document {
			color: #2e73d6;
			font-size: 18px;
			margin-right: 8px;
		}

		.file-name {
			flex: 1;
			color: $label-color;
			word-break: break-all;
			margin-right: 12px;
		}
	}
</style>
